import React from 'react'
import './Panel.css'

export const Panel = props => (
    <div className="panel">
        {props.title && <h2>{props.title}</h2>}

        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/common/Panel.js